
export class price {
   
    id: number;
    serviceName:string;
    yearrangeStart:number;
    yearrangeEnd: number;
    amount:number;
    created_by:string;
    securitycharge:number;
    gst:number;
    documentType:string;
    requestTypeId :number;
    doctypeId:number;
    }